import React, { useState, useEffect, useContext } from 'react';
import AiExecutionLoader from '../component/AiExrcutionLoader';
import { PostCallWithErrorResponse,simpleGetCallWithErrorResponse } from '../Api/ApiServices';
import { ApiConfig } from '../Api/ApiConfig';
import { toastMsg } from '../component/toast';
import CustomSelect from '../constant/customselect';
import { arraysEqual } from '../common';
import MultiSelectSearchDropdown from '../component/MulteSelectSearch';
import { AppContext } from '../context/AppContext';


/******************************************************************************
 * LIVE INTEGRATION STEPS:
 * 1. Replace `ApiConfig` and `PostCallWithErrorResponse` with your real API calls.
 * 2. Fetch `JOB_ROLES_MOCK` from your backend or configure it globally.
 * 3. Extract `LYWO_CSS` into a separate `.css` file and import it.
 * 4. Replace `Icons` with your project's standard icon library (e.g., lucide-react).
 ******************************************************************************/


const generateId = () => {
    if (typeof crypto !== 'undefined' && crypto.randomUUID) {
        return crypto.randomUUID();
    }
    return Math.random().toString(36).substring(2, 15);
};


// const ApiConfig = {
//     REPLACE_QUEST: 'REPLACE_QUEST',
//     GET_SUB_TOPICS: 'GET_SUB_TOPICS',
//     GET_QUIZ_QUES: 'GET_QUIZ_QUES',
//     CREATE_UPDATE_QUIZ: 'CREATE_UPDATE_QUIZ',
//     EXTRACT_TOPICS: 'EXTRACT_TOPICS'
// };


const JOB_ROLES_MOCK = [
    { id: 1, title: 'Senior Frontend Developer (React)', topics: ['Frontend', 'React', 'JavaScript', 'CSS', 'Web Performance'] },
    { id: 2, title: 'Backend Engineer (Node.js)', topics: ['Backend', 'Node.js', 'API Design', 'Database', 'Security'] },
    { id: 3, title: 'DevOps Engineer', topics: ['DevOps', 'AWS', 'Docker', 'Kubernetes', 'CI/CD'] },
    { id: 4, title: 'UI/UX Designer', topics: ['Design', 'Figma', 'Prototyping', 'User Research', 'Accessibility'] },
    { id: 5, title: 'Full Stack Developer', topics: ['React', 'Node.js', 'TypeScript', 'MongoDB', 'Express'] },
    { id: 6, title: 'Data Engineer', topics: ['Python', 'SQL', 'ETL', 'Spark', 'Data Warehousing'] },
    { id: 7, title: 'QA Automation Engineer', topics: ['Testing', 'Selenium', 'Cypress', 'Jest', 'CI/CD'] },
    { id: 8, title: 'Product Manager', topics: ['Agile', 'Scrum', 'Roadmap', 'User Stories', 'Jira'] },
    { id: 9, title: 'Mobile App Developer', topics: ['Flutter', 'React Native', 'iOS', 'Android', 'Dart'] },
    { id: 10, title: 'Cloud Architect', topics: ['AWS', 'Azure', 'System Design', 'Security', 'Networking'] }
];


// const PostCallWithErrorResponse = async (url, payload) => {
//     console.log(`[Mock API] POST ${url}`, payload);
//     return new Promise(resolve => {
//         setTimeout(() => {
//             if (url === ApiConfig.EXTRACT_TOPICS) {
//                 const mockTopics = ["React Component Lifecycles", "State Management", "API Integration", "UI/UX Principles"];
//                 resolve({ json: { topics: mockTopics } });
//             } else if (url === ApiConfig.GET_SUB_TOPICS) {
//                 const mockResponse = (payload.topics || []).map(t => ({
//                     topic: t,
//                     subtopics: [
//                         `Fundamentals of ${t}`,
//                         `${t} Best Practices`,
//                         `Advanced ${t} Concepts`,
//                         `${t} Performance Optimization`,
//                         `${t} Tools & Ecosystem`,
//                         `Security in ${t}`,
//                         `Testing ${t} Applications`,
//                         `Deployment Strategies for ${t}`
//                     ]
//                 }));
//                 resolve({ json: { sub_topics: mockResponse } });
//             } else if (url === ApiConfig.GET_QUIZ_QUES) {
//                 const count = payload.num_questions || 3;
//                 const newQs = Array(parseInt(count)).fill(0).map((_, i) => ({
//                     q: `AI Generated Question ${i + 1} about ${payload.topics?.[0] || 'Topic'}`,
//                     options: ["Option A", "Option B", "Option C", "Option D"],
//                     correct_answer: "Option A",
//                     rationale: "AI Explanation for why Option A is correct. This concept is fundamental to understanding the core topic.",
//                     weight: 1,
//                     type: "MCQ"
//                 }));
//                 resolve({ json: { quiz: { quiz_questions: newQs } } });
//             } else {
//                 resolve({ json: { success: true } });
//             }
//         }, 800);
//     });
// };


const Icons = {
    Edit: (p) => <svg {...p} width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" /><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" /></svg>,
    Trash: (p) => <svg {...p} width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="3 6 5 6 21 6" /><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" /></svg>,
    Check: (p) => <svg {...p} width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12" /></svg>,
    Close: (p) => <svg {...p} width="1em" height="1em" style={{fontSize:'var(--font-size-h4)'}} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" /></svg>,
    Sparkles: (p) => <svg {...p} width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="m12 3-1.912 5.813a2 2 0 0 1-1.275 1.275L3 12l5.813 1.912a2 2 0 0 1 1.275 1.275L12 21l1.912-5.813a2 2 0 0 1 1.275-1.275L12 3Z" /><path d="M5 3v4" /><path d="M9 5H3" /><path d="M19 19v2" /><path d="M21 20h-2" /></svg>,
    Plus: (p) => <svg {...p} width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="12" y1="5" x2="12" y2="19" /><line x1="5" y1="12" x2="19" y2="12" /></svg>
};


const LYWO_CSS = `
@charset "UTF-8";
@import url("https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap");


:root {
  --brand-primary: #081DA5;
  --brand-indigo: #6366f1;
  --brand-bg: #f5f8ff;
  --brand-text: #1F222A;
  --color-info-bg: #eef2ff;
  --color-success-bg: #d1e7dd; --color-success-text: #198754;
  --color-warning-bg: #fff3cd; --color-warning-text: #856404;
  --color-danger-bg: #f8d7da; --color-danger-text: #dc3545;
  --ui-gray-bg: #F2F4F7;
  --ui-border: #d0d5dd;
  --ui-text-muted: #6b7280;
  --ui-text-dark: #1F222A;
  --radius-md: 0.5rem;
  --radius-lg: 0.75rem;
}




.wizard-btn-next { background-color: var(--brand-primary); color: white; padding: 8px 24px; border-radius: 6px; font-weight: 500; border: none; font-size: 14px; cursor: pointer; }
.wizard-btn-next:hover { background-color: #4f46e5; }
.wizard-btn-next:disabled { background-color: #a5b4fc; cursor: not-allowed; }
.wizard-link-back { color: var(--brand-primary); background: transparent; border: none; font-weight: 500; font-size: 14px; cursor: pointer; padding: 8px 16px; text-decoration: none; }
.wizard-link-back:hover { text-decoration: underline; }


.form-control { color: var(--ui-text-dark); font-size: 13px; font-weight: 400; border-radius: 6px; min-height: 40px; border: 1px solid var(--ui-border); padding: 0.5rem 0.75rem; background: #fff; width: 100%; box-shadow: 0 1px 2px rgba(0,0,0,0.02); }
.form-control:focus { outline: none; border-color: var(--brand-primary); box-shadow: 0 0 0 2px rgba(99, 102, 241, 0.2); }
.form-label { font-size: 13px; font-weight: 600; color: var(--ui-text-dark); margin-bottom: 6px; display: block; }


.topic-chip { display: inline-flex; align-items: center; padding: 6px 14px; border-radius: 50rem; font-size: 13px; font-weight: 500; cursor: pointer; border: 1px solid var(--ui-border); background-color: #fff; transition: all 0.2s ease; }
.topic-chip:hover { background-color: #f9fafb; border-color: #d1d5db; }
.topic-chip.selected { background-color: var(--brand-primary); border-color: var(--brand-primary); color: #fff; }


.card-std { background: #fff; border: 1px solid var(--ui-border); border-radius: 12px; padding: 16px; transition: 0.3s; position: relative; margin-bottom: 0.75rem; font-size: 13px; }
.information-card { display: inline-flex; align-items: center; justify-content: center; gap: 8px; padding: 6px 12px; border-radius: 6px; background-color: var(--color-warning-bg); color: var(--color-warning-text); border: 1px solid var(--color-warning-text); font-size: 11px; font-weight: 500; line-height: 1.25; }


.custom-modal-overlay { position: fixed; inset: 0; background-color: rgba(0,0,0,0.4); z-index: 1050; display: flex; align-items: center; justify-content: center; animation: fadeIn 0.2s ease-out; backdrop-filter: blur(2px); font-family: 'Inter', sans-serif; }
.custom-modal-dialog { background: #f8fafc; width: 100%; max-height: 90vh; border-radius: 12px; box-shadow: 0 20px 25px -5px rgba(0,0,0,0.1), 0 10px 10px -5px rgba(0,0,0,0.04); display: flex; flex-direction: column; overflow: hidden; animation: slideUp 0.3s ease-out; }
.custom-modal-header { padding: 1.25rem 2rem 0 2rem; display: flex; flex-direction: column; background: transparent; }
.custom-modal-body { padding: 1.5rem 2rem; flex: 1; overflow: hidden; background: transparent; display: flex; flex-direction: column; }
.custom-modal-footer { padding: 1rem 2rem; background: transparent; display: flex; justify-content: flex-end; align-items: center; gap: 1rem; border-top: 1px solid var(--ui-border); flex-shrink: 0; }
.anim-fade { animation: fadeIn 0.3s ease-out; }


.lywo-modal-content { display: flex; flex-direction: column; flex: 1; min-height: 0; }


.hide-scrollbar::-webkit-scrollbar { display: none; }
.hide-scrollbar { -ms-overflow-style: none; scrollbar-width: none; }


.wizard-tabs-container { display: flex; gap: 24px; border-bottom: 1px solid #e5e7eb; margin-bottom: 8px; }
.wizard-tab { padding: 12px 0; font-size: 14px; font-weight: 500; color: #6b7280; background: none; border: none; border-bottom: 2px solid transparent; cursor: pointer; transition: all 0.2s; }
.wizard-tab.active { color: var(--brand-primary); border-bottom-color: var(--brand-primary); }
.wizard-tab:disabled { opacity: 0.5; cursor: not-allowed; }


.context-header { font-size: 13px; color: #4b5563; display: flex; flex-direction: column; gap: 4px; justify-content: flex-start; }


@keyframes fadeIn { from { opacity: 0; transform: translateY(5px); } to { opacity: 1; transform: translateY(0); } }
@keyframes slideUp { from { opacity: 0; transform: translateY(20px); } to { opacity: 1; transform: translateY(0); } }
`;


const Modal = ({ title, onClose, children, footer, size = '600px', dialogClassName = '' }) => (
    <div className="custom-modal-overlay">
        <div className={`custom-modal-dialog ${dialogClassName}`} style={{ maxWidth: size }}>
            <div className="custom-modal-header">
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', width: '100%' }}>
                    <div style={{ flex: 1 }}>{title}</div>
                    <button onClick={onClose} className="text-muted" style={{ background: 'none', border: 'none', cursor: 'pointer', padding: '4px', marginTop: '8px' }} title="Close"><Icons.Close /></button>
                </div>
            </div>
            <div className="custom-modal-body">
                {children}
            </div>
            {footer && <div className="custom-modal-footer">{footer}</div>}
        </div>
    </div>
);

const AiWizardModal = ({ onClose, onImport, initialTopic,
setSelectedJobData,
selectedJobData

}) => {

    

    const [activeTab, setActiveTab] = useState('linkedJob');
    const [jobType, setJobType] = useState(selectedJobData.type || 'draft');
    const [selectedJobId, setSelectedJobId] = useState(  '');
    const [selectedJob, setSelectedJob] = useState( null);
    const [selectedTopics, setSelectedTopics] = useState([]);
    const [customTopic, setCustomTopic] = useState('');
    const [topics, setTopics] = useState([]);
    const [selectedSubTopics, setSelectedSubTopics] = useState([]);
    const [customSubTopic, setCustomSubTopic] = useState('');
    const [subTopics, setSubTopics] = useState([]);
    const [flatSubTopicsList, setFlatSubTopicsList] = useState([]);
    const [count, setCount] = useState(5);
    const [difficulty, setDifficulty] = useState('Medium');
    const [questions, setQuestions] = useState([]);
    const [loading, setLoading] = useState(false);
    const [topicsJobOpen, setTopicsJobOpen] = useState(false);
    const [subTabJobOpen, setSubTabJobOpen] = useState(false);
    const [subTabTopicsOpen, setSubTabTopicsOpen] = useState(false);
    const [settingsJobOpen, setSettingsJobOpen] = useState(false);
    const [settingsTopicsOpen, setSettingsTopicsOpen] = useState(false);
    const [settingsSubTopicsOpen, setSettingsSubTopicsOpen] = useState(false);

    const {adminData} = useContext(AppContext)

    const [isLoading,setIsloading] = useState(false);

    const [isGenerating, setIsGenarating] = useState(false);

    const [codeList,setCodeList] = useState([]);
    const [draftList,setDraftList] = useState([]);

    const [previousSelected,setPreviousSelected] =useState({
        selectedJob:'',
        selectedTopics:[],
        selectedSubTopics:[],
        noOfQues:'',
        difficulty:''
    })

    const canAccessTopics = true;
    const canAccessSubtopics = selectedTopics.length > 0;
    const canAccessConfig = selectedSubTopics.length > 0;
    const canAccessReview = canAccessConfig;
    const hasQuestions = questions.length > 0;

    const [selectedJobOrDraft,setSelectedJobOrDraft]=useState({
        description:selectedJobData.description,
        selected:selectedJobData.id
    })

    const handleNext = (nextTab) => setActiveTab(nextTab);

    const handleSkip = () => {
        setSelectedJobId('');
        setSelectedJob(null);
        setActiveTab('topics');
    };

    useEffect(()=>{

        if(selectedJobData.id){
            setActiveTab('topics')
        }

    },[])

    useEffect(()=>{

        if( activeTab==='topics'){

            getTopics();

        }

    },[activeTab])

    useEffect(()=>{
        getCodesAndDraftList()
    },[])

    const getTopics =()=>{

        if(topics.length>0&& selectedJobOrDraft.selected==previousSelected.selectedJob) {

            handleNext('topics')
            return
        };

        setIsloading(true);

        PostCallWithErrorResponse(ApiConfig.GET_TOPISC,{
            job_description: selectedJobOrDraft.description
        }).then((res)=>{

            if(res?.json?.status==200){

                setPreviousSelected(prev=>({
                    ...prev,
                    selectedJob:selectedJobOrDraft.selected,
                }))

                setSelectedTopics([]);

                setSelectedSubTopics([]);

                setFlatSubTopicsList([]);

                setTopics(res?.json?.quiz_topics || []);
                

            }else{

            toastMsg('error', res?.json?.message || 'Failed to fetch topics. Please try again.');

            }


            setIsloading(false);


        })

    }

    const handleJobSelectChange = (e) => {
        const jobId = e.target.value;
        setSelectedJobId(jobId);
        const job = JOB_ROLES_MOCK.find(j => j.id.toString() === jobId);
        setSelectedJob(job || null);
        if (job) {
            setTopics(prev => [...new Set([...prev, ...job.topics])]);
            setSelectedTopics(job.topics.slice(0, 5));
        } else {
            setSelectedTopics([]);
        }
    };


    const storePreviousSlctTopics =()=>{

        setPreviousSelected(prev=>({
            ...prev,
            selectedTopics:selectedTopics
        }))

    }
    const getSubSubTopics = () => {

        if(flatSubTopicsList.length>0 && arraysEqual(previousSelected.selectedTopics,selectedTopics) ){
           
            handleNext('subTopics')
            return 
        }

        setIsloading(true)

        handleNext('subTopics')

        PostCallWithErrorResponse(ApiConfig.GET_SUB_TOPICS, {
            job_description: selectedJobOrDraft.description,
            topics: selectedTopics
        }).then((res) => {
            if (res?.json?.status==200) {

                 let allSubTopics =[];

                 let suggestedSubTopics = [];

                 res.json.sub_topics.forEach(group=>{

                    allSubTopics.push(...group.recommended_subtopics,...group.unrecommended_subtopics);

                    suggestedSubTopics.push(...group.recommended_subtopics);

                 })
                 setSelectedSubTopics(suggestedSubTopics)
                setFlatSubTopicsList(allSubTopics);
               
            }else{
                toastMsg('error', res?.json?.message || 'Failed to fetch subtopics. Please try again.');
            }

            setIsloading(false);
        });
    }




    const handleAddCustomTopic = (e) => {
        if (e.key === 'Enter' && customTopic.trim()) {
            const newTopic = customTopic.trim();
            setTopics(prev => [...prev, newTopic]);
            if(selectedTopics.length<1){
             setSelectedTopics(prev => [...prev, newTopic]);
            }
            setCustomTopic('');
        }
    };

    const handleAddCustomSubTopic = (e) => {
        if (e.key === 'Enter' && customSubTopic.trim()) {
            const newSubTopic = customSubTopic.trim();
            setFlatSubTopicsList(prev => [newSubTopic, ...prev]);
            if (selectedSubTopics.length < 5) setSelectedSubTopics(prev => [...prev, newSubTopic]);
            setCustomSubTopic('');
        }
    };

    const generate = () => {
        console.log(previousSelected.selectedSubTopics,selectedSubTopics);

        if(previousSelected.noOfQues==count &&
             previousSelected.difficulty==difficulty &&
             arraysEqual(previousSelected.selectedSubTopics,selectedSubTopics)
         ){

        setActiveTab('review');
            return
        }

        
        
        if (!canAccessConfig) return alert("Please complete previous steps.");

        setIsGenarating(true);
        setLoading(true);
        setIsloading(true)

        setActiveTab('review');
        PostCallWithErrorResponse(ApiConfig.GET_QUIZ_QUES, {
            difficulty_level: difficulty,
            job_description: selectedJobOrDraft.description,
            num_questions: count,
            topics: selectedSubTopics
        }).then((res) => {
            if (res?.json?.quiz?.quiz_questions) {
                setQuestions(res?.json?.quiz?.quiz_questions);

            setIsGenarating(false);

            setPreviousSelected(prev=>({
                ...prev,
                noOfQues:count,
                difficulty:difficulty,
                selectedSubTopics:selectedSubTopics
            }))
           
      
            }

            setIsloading(false);
            setLoading(false);
        });
    };

    const getCodesAndDraftList=()=>{

        simpleGetCallWithErrorResponse(ApiConfig.GET_CODE_LIST_WITH_ABOUT_JOB).then((res)=>{
            if(res?.json?.succeded){

                setCodeList(res?.json?.response?.codeList || []);
                setDraftList(res?.json?.response?.jdList || []);

            }

        })

    }

    const remove = (idx) => setQuestions(prev => prev.filter((_, i) => i !== idx));

    const handleImport = () => {
        const questionsMap = questions?.map((ques) => ({
            ...ques,
            // id: generateId(),
            weight: 1,
            type: "MCQ",
            text: ques.q
        }));
        console.log(questionsMap);
        onImport(questionsMap);
    };

    const renderTabs = (
        <div className="wizard-tabs-container" style={{
            borderBottom: 'none',
            minHeight: '50px',
            overflowAnchor: 'none'
        }}>
            <button className={`font-size-h4 wizard-tab ${activeTab === 'linkedJob' ? 'active' : ''}`} onClick={() => setActiveTab('linkedJob')}>Linked Job</button>
            <button className={`font-size-h4 wizard-tab ${activeTab === 'topics' ? 'active' : ''}`} onClick={() => canAccessTopics && setActiveTab('topics')} disabled={!canAccessTopics}>Topics</button>
            <button className={`font-size-h4 wizard-tab ${activeTab === 'subTopics' ? 'active' : ''}`} onClick={() => flatSubTopicsList?.length && setActiveTab('subTopics')} disabled={!flatSubTopicsList?.length}>Sub Topics</button>
            <button className={`font-size-h4 wizard-tab ${activeTab === 'settings' ? 'active' : ''}`} onClick={() => canAccessConfig && setActiveTab('settings')} disabled={!canAccessConfig}>Settings</button>
            <button className={`font-size-h4 wizard-tab ${activeTab === 'reviewConfig' ? 'active' : ''}`} onClick={() => canAccessReview && setActiveTab('reviewConfig')} disabled={!canAccessReview}>Review</button>
            <button className={`font-size-h4 wizard-tab ${activeTab === 'review' ? 'active' : ''}`} onClick={() => hasQuestions && setActiveTab('review')} disabled={!hasQuestions}>Questions</button>
        </div>
    );
    const outlineButtonStyle = {
        fontSize: 'var(--font-size-base)',
        fontWeight: '400',
        marginRight: '10px',
        padding: '6px 16px',
        border: '1px solid var(--brand-primary)',
        borderRadius: '6px',
        background: 'transparent',
        color: 'var(--brand-primary)',
        cursor: 'pointer'
    };

    const modalFooter = (
        <>
            {activeTab === 'linkedJob' && (
                <>
                    <button className="btn btn-primary" disabled={isLoading} onClick={() => setActiveTab('topics')}>Next</button>
                </>
            )}
            {activeTab === 'topics' && (
                <>
                    <div style={{ display: 'flex', justifyContent: 'flex-start' }}>
                        <button
                            className="btn btn-outline-primary"
                            style={outlineButtonStyle}
                            onClick={() => setActiveTab('linkedJob')}
                        >
                            Back
                        </button>
                    </div>
                    <button className="btn btn-primary" disabled={isLoading || !selectedTopics?.length} onClick={() => getSubSubTopics()}>Next</button>
                </>
            )}
            {activeTab === 'subTopics' && (
                <>
                    <div style={{ display: 'flex', justifyContent: 'flex-start' }}>
                        <button
                            className="btn btn-outline-primary"
                            style={outlineButtonStyle}
                            onClick={() => {
                                storePreviousSlctTopics()
                                setActiveTab('topics')
                        }}
                        >
                            Back
                        </button>
                    </div>
                    <button className="btn btn-primary" disabled={!canAccessConfig} onClick={() =>{ 
                       
                        handleNext('settings')}}>Next</button>
                </>
            )}
            {activeTab === 'settings' && !loading && (
                <>
                    <div style={{ display: 'flex', justifyContent: 'flex-start' }}>
                        <button className="btn btn-outline-primary" style={outlineButtonStyle} onClick={() => setActiveTab('subTopics')}>Back</button>
                    </div>
                    <button className="btn btn-primary" onClick={() => setActiveTab('reviewConfig')}>Next</button>
                </>
            )}
            {activeTab === 'reviewConfig' && (
                <>
                    <div style={{ display: 'flex', justifyContent: 'flex-start' }}>
                        <button className="btn btn-outline-primary" style={outlineButtonStyle} onClick={() => setActiveTab('settings')}>Back</button>
                    </div>
                    <button className="btn btn-primary" onClick={generate}>Generate</button>
                </>
            )}
            {activeTab === 'review' && (
                <>
                    <div style={{ display: 'flex', justifyContent: 'flex-start' }}>
                        <button className="btn btn-outline-primary" style={outlineButtonStyle} onClick={() => setActiveTab('reviewConfig')}>Back</button>
                    </div>
                    <button className="btn btn-primary" onClick={handleImport}>Import</button>
                </>
            )}
        </>
    );
    // taleeb
    return (
        <>
        <Modal title={renderTabs} onClose={onClose} size="800px" dialogClassName="modal-h-650" footer={ isLoading?null:modalFooter}>
            <div className="lywo-modal-content">
                {
                    isLoading ? (
                        <div className="d-flex justify-content-center align-items-center vh-100">
                        <div
                            className={`spinner-border text-primary`}
                            role="status"
                            style={{ width: "40px", height: "40px" }}
                        />
                        </div>
                    ):
                    <>{activeTab === 'linkedJob' && (
                    <div className="context-header" style={{ flexShrink: 0, marginBottom: '16px' }}>
                        <div style={{ display: 'flex', gap: '2rem', paddingBottom: '4px', height: '20px' }}>
                            <label className={`form-label fw-medium d-flex align-items-center ${jobType === 'posted' ? 'text-brand-primary' : 'text-dark-ui'}`} style={{ gap: '8px', cursor: 'pointer' }}>
                                <input type="radio" name="jobType" value="posted" checked={jobType === 'posted'} onChange={(e) =>{ setJobType(e.target.value)

setSelectedJobData(prev=>({
    ...prev,
    type:e.target.value
}))

                                }} style={{ accentColor: 'var(--brand-primary)' }} />
                                Posted Job
                            </label>
                            <label className={`form-label fw-medium d-flex align-items-center ${jobType === 'draft' ? 'text-brand-primary' : 'text-dark-ui'}`} style={{ gap: '8px', cursor: 'pointer' }}>
                                <input type="radio" name="jobType" value="draft" checked={jobType === 'draft'} onChange={(e) =>{ setJobType(e.target.value)
setSelectedJobData(prev=>({
    ...prev,
    type:e.target.value
}))


                                }} style={{ accentColor: 'var(--brand-primary)' }} />
                                Draft Job
                            </label>
                        </div>
                    </div>
                )}

                <div className="hide-scrollbar" style={{ flex: 1, display: 'flex', flexDirection: 'column', overflowY: 'auto' }}>
                    {activeTab === 'linkedJob' && (
                        <div style={{ width: '100%' }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0' }}>
                                <span className="font-size-h4 fw-semibold text-dark-ui" style={{ margin: 0 }}>Select Job</span>
                                <button style={{ background: 'none', border: 'none', color: 'var(--brand-primary)', fontWeight: 500, fontSize: '14px', cursor: 'pointer', padding: '0', textDecoration: 'none' }} onClick={handleSkip}>Skip</button>
                            </div>
                            {
                                adminData?.admin==='Admin'?
                            
                            <MultiSelectSearchDropdown
                              searchFliedPlaceHolder={'Search job title or company name...'}
                              placeHolder={jobType === 'posted'?"Select Posted Job":"Select Draft Job"}
                              options={jobType === 'posted'?
                                codeList?.map((i)=>({
                                    label:i?.position+' - ('+i?.company+")",
                                    value:i?.codeid,
                                    details:i
                                }))
                                :draftList?.map((i)=>({
                                label:i?.position+' - ('+i?.company+")",
                                value:i?.jdid,
                                details:i
                              }))}
                              isMulti={false}
                              labelKey={'label'}
                              valKey={"value"}
                              value={selectedJobOrDraft.selected||""}
                              handleValuesChange={(e,data)=>{


                                        let description=jobType == 'posted'?data?.details?.about_Job||"":data?.details?.description || ''


                                        setSelectedJobOrDraft({
                                            selected:e,
                                            description:description,
                                            label:data.label
                                        })

                                        setSelectedJobData(prev=>({
    ...prev,
    id:e,
    description:description,
    label:data.label
}))
                                

                              }}
                            />
                            :
                            <CustomSelect
                                    value={selectedJobOrDraft.selected}
                                    options={jobType === 'posted'?codeList:draftList}
                                    labelKey={jobType === 'posted'?'code':'position'}
                                     valKey={jobType === 'posted'?'codeid':'jdid'}
                                    placeholder={jobType === 'posted'?'Select Code':'Select Draft'}
                                    handleChange={(e, data) => {


                                        let description=jobType == 'posted'?data?.details?.about_Job||"":data?.details?.description || ''


                                        setSelectedJobOrDraft({
                                            selected:e,
                                            description:description,
                                            label:data.label
                                        })

                                        setSelectedJobData(prev=>({
    ...prev,
    id:e,
    description:description,
    label:data.label
}))
                                     

                                    }}
                                    isClearaAble={false}
                                />
}
                            {/* <select
                                className="form-select"
                                value={selectedJobId}
                                onChange={handleJobSelectChange}
                                style={{ width: '100%', backgroundImage: `url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23374151' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6 9 12 15 18 9'%3e%3c/polyline%3e%3c/svg%3e")`, backgroundRepeat: 'no-repeat', backgroundPosition: 'right 12px center', backgroundSize: '16px', paddingRight: '36px', appearance: 'none' }}
                            >
                                <option className='font-size-base' value="">-- Select a Job --</option>
                                {
                                    jobType === 'posted' ? (
                                        JOB_ROLES_MOCK.map(role => (
                                            <option key={role.id} value={role.id}>{role.title}</option>
                                        ))
                                    ):(
                                        JOB_ROLES_MOCK.map(role => (
                                            <option key={role.id} value={role.id}>{role.title}</option>
                                        ))
                                    )
                                }
                                {}
                            </select> */}
                        </div>
                    )}

                    {activeTab === 'topics' && (
                        <div style={{ width: '100%', display: 'flex', flexDirection: 'column', height: '100%' }}>
                            {/* Selected Job collapsible */}
                            <div style={{ flexShrink: 0, marginBottom: '16px' }}>
                                <div
                                    style={{ display: 'flex', alignItems: 'center', gap: '6px', cursor: 'pointer', userSelect: 'none' }}
                                    onClick={() => setTopicsJobOpen(prev => !prev)}
                                >
                                    <span className="font-size-h4 fw-semibold text-dark-ui">Selected Job</span>
                                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={{ transform: topicsJobOpen ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.2s' }}>
                                        <polyline points="6 9 12 15 18 9" />
                                    </svg>
                                </div>
                                {topicsJobOpen && (
                                    <div style={{ marginTop: '6px' }}>
                                        {selectedJobOrDraft.selected ? (
                                            <span style={{ display: 'inline-flex', alignItems: 'center', padding: '3px 12px', borderRadius: '50rem', fontSize: '11px', fontWeight: 500, background: 'transparent', color: 'var(--brand-primary)', border: '1.5px solid var(--brand-primary)' }}>
                                                {selectedJobOrDraft.label}
                                            </span>
                                        ) : (
                                            <span className="font-size-base " style={{ fontStyle: 'italic' }}>None Selected</span>
                                        )}
                                    </div>
                                )}
                            </div>

                            {/* Select Topics */}
                            <div className='margin-btn-input' style={{ flexShrink: 0, width: '100%' }}>
                                <span className="font-size-h4 fw-semibold text-dark-ui">Select Topic</span>
                                <div style={{ position: 'relative', width: '100%', display: 'block' }}>
                                    <input
                                        className="font-size-base form-control"
                                        placeholder="Add Custom Topic"
                                        value={customTopic}
                                        onChange={(e) => setCustomTopic(e.target.value)}
                                        onKeyDown={handleAddCustomTopic}
                                        style={{ width: '100%', paddingRight: '40px', boxSizing: 'border-box' }}
                                    />
                                    <div
                                        className="text-muted d-flex align-items-center justify-content-center"
                                        style={{ position: 'absolute', right: '0', top: '0', height: '100%', width: '40px', cursor: 'pointer' }}
                                        onClick={() => handleAddCustomTopic({ key: 'Enter' })}
                                    >
                                        <Icons.Plus />
                                    </div>
                                </div>
                            </div>

                            <div className="hide-scrollbar" style={{ flex: 1, overflowY: 'auto', alignContent: 'flex-start' }}>
                                <div style={{ display: 'flex', gap: '4px', flexWrap: 'wrap', paddingBottom: '12px' }}>
                                    {topics.map((t, idx) => {
                                        const isSelected = selectedTopics.includes(t);
                                        return (
                                            <button
                                                key={`${t}-${idx}`}
                                                onClick={() => {
                                                    if (isSelected) {
                                                        setSelectedTopics(prev => prev.filter(x => x !== t));
                                                    } else {

                                                        if(selectedTopics.length<1){

                                                        setSelectedTopics(prev => [...prev, t]);
                                                        }else{
                                                            toastMsg('error','Maximum 1 topics allowed')
                                                        }

                                                    }
                                                }}
                                                style={isSelected ? { background: 'var(--brand-primary)', color: '#fff', border: '1.5px solid var(--brand-primary)', fontWeight: 600 } : {}}
                                                className={`font-size-h4 topic-chip`}
                                            >
                                                {t}
                                            </button>
                                        );
                                    })}
                                </div>
                            </div>
                        </div>
                    )}

                    {activeTab === 'subTopics' && (
                        <>
                        <div style={{ width: '100%', display: 'flex', flexDirection: 'column', height: '100%' }}>

                            {/* Selected Job collapsible */}
                            <div style={{ flexShrink: 0, marginBottom: '12px' }}>
                                <div
                                    style={{ display: 'flex', alignItems: 'center', gap: '6px', cursor: 'pointer', userSelect: 'none' }}
                                    onClick={() => setSubTabJobOpen(prev => !prev)}
                                >
                                    <span className="font-size-h4 fw-semibold text-dark-ui">Selected Job</span>
                                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={{ transform: subTabJobOpen ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.2s' }}>
                                        <polyline points="6 9 12 15 18 9" />
                                    </svg>
                                </div>
                                {subTabJobOpen && (
                                    <div style={{ marginTop: '6px' }}>
                                        {selectedJobOrDraft.selected ? (
                                            <span style={{ display: 'inline-flex', alignItems: 'center', padding: '3px 12px', borderRadius: '50rem', fontSize: '11px', fontWeight: 500, background: 'transparent', color: 'var(--brand-primary)', border: '1.5px solid var(--brand-primary)' }}>
                                                {selectedJobOrDraft.label}
                                            </span>
                                        ) : (
                                            <span className="font-size-base " style={{ fontStyle: 'italic' }}>None Selected</span>
                                        )}
                                    </div>
                                )}
                            </div>

                            {/* Selected Topics collapsible */}
                            <div style={{ flexShrink: 0, marginBottom: '12px' }}>
                                <div
                                    style={{ display: 'flex', alignItems: 'center', gap: '6px', cursor: 'pointer', userSelect: 'none' }}
                                    onClick={() => setSubTabTopicsOpen(prev => !prev)}
                                >
                                    <span className="font-size-h4 fw-semibold text-dark-ui">Selected Topics</span>
                                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={{ transform: subTabTopicsOpen ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.2s' }}>
                                        <polyline points="6 9 12 15 18 9" />
                                    </svg>
                                </div>
                                {subTabTopicsOpen && (
                                    <div style={{ marginTop: '6px', display: 'flex', flexWrap: 'wrap', gap: '4px' }}>
                                        {selectedTopics.length > 0 ? selectedTopics.map((t, idx) => (
                                            <span key={idx} style={{ display: 'inline-flex', alignItems: 'center', padding: '2px 10px', borderRadius: '50rem', fontSize: '12px', fontWeight: 600, background: 'transparent', color: 'var(--brand-primary)', border: '1.5px solid var(--brand-primary)' }}>{t}</span>
                                        )) : <span className="font-size-base" style={{ fontStyle: 'italic' }}>None Selected</span>}
                                    </div>
                                )}
                            </div>

                            {/* Select Subtopics input */}
                            <div className='margin-btn-input' style={{ flexShrink: 0, width: '100%' }}>
                                <span className="font-size-h4 fw-semibold text-dark-ui">Select Subtopics</span>
                                <div style={{ position: 'relative', width: '100%', display: 'block' }}>
                                    <input
                                        className="font-size-base form-control"
                                        placeholder="Add Custom Sub Topic"
                                        value={customSubTopic}
                                        onChange={(e) => setCustomSubTopic(e.target.value)}
                                        onKeyDown={handleAddCustomSubTopic}
                                        style={{ width: '100%', paddingRight: '40px', boxSizing: 'border-box' }}
                                    />
                                    <div
                                        className="text-muted d-flex align-items-center justify-content-center"
                                        style={{ position: 'absolute', right: '0', top: '0', height: '100%', width: '40px', cursor: 'pointer' }}
                                        onClick={() => handleAddCustomSubTopic({ key: 'Enter' })}
                                    >
                                        <Icons.Plus />
                                    </div>
                                </div>
                            </div>

                            <div className="hide-scrollbar" style={{ flex: 1, overflowY: 'auto', alignContent: 'flex-start' }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '8px' }}>
                                    <span className="font-size-h4 fw-semibold text-dark-ui">Sub Topics</span>
                                </div>
                                {/* {flatSubTopicsList.length === 0 ? (
                                    <div className="font-size-h4" style={{ textAlign: 'center', padding: '2rem', fontStyle: 'italic' }}>
                                        None Selected
                                    </div>
                                ) : (
                                    <div style={{ display: 'flex', gap: '4px', flexWrap: 'wrap', padding: '4px 0' }}>
                                        {flatSubTopicsList.map((t, idx) => {
                                            const isSelected = selectedSubTopics.includes(t);
                                            return (
                                                <button
                                                    key={`${t}-${idx}`}
                                                    onClick={() => {
                                                        if (isSelected) {


                                                            setSelectedSubTopics(prev => prev.filter(x => x !== t));
                                                            
                                                        } else {

                                                            if(selectedSubTopics.length<5){
                                                            setSelectedSubTopics(prev => [...prev, t]);
                                                            }else{
                                                                toastMsg('error','Maximum 5 sub-topics allowed')
                                                            }
                                                        }
                                                    }}
                                                    style={isSelected ? { background: 'var(--brand-primary)', color: '#fff', border: '1.5px solid var(--brand-primary)', fontWeight: 600 } : {}}
                                                    className={`font-size-h4 topic-chip`}
                                                >
                                                    {t}
                                                </button>
                                            );
                                        })}
                                    </div>
                                )} */}
                            
                        {flatSubTopicsList.length === 0 ? (
                                    <div className="font-size-h4" style={{ textAlign: 'center', padding: '2rem', fontStyle: 'italic' }}>
                                        None Selected
                                    </div>
                                ) : (
                        <div className="row hide-scrollbar" style={{overflow:'auto'}}>
  {flatSubTopicsList.map((t, idx) => {
    const isSelected = selectedSubTopics.includes(t);
    const id = `subtopic-${idx}`;

    return (
      <div className="col-4 " style={{marginBottom:'2px'}} key={id}>
        <div className="form-check d-flex align-items-center gap-2 m-0 p-0">
  <input
    className="form-check-input m-0"
    type="checkbox"
    id={id}
    checked={isSelected}
    onChange={() => {
      if (isSelected) {
        setSelectedSubTopics((prev) => prev.filter((x) => x !== t));
      } else {
        if (selectedSubTopics.length < 5) {
          setSelectedSubTopics((prev) => [...prev, t]);
        } else {
          toastMsg("error", "Maximum 5 sub-topics allowed");
        }
      }
    }}
  />

  <label
    className="form-check-label m-0 fw-bold"
    htmlFor={id}
    style={{
      cursor: "pointer",
      fontWeight: isSelected ? 600 : 400,
      color: isSelected ? "var(--brand-primary)" : "",
      lineHeight: 1.2,
    }}
  >
    {t}
  </label>
</div>
      </div>
    );
  })}
</div>
                                )
                            }
                            </div>
                        </div>
                        </>
                    )}

                    {activeTab === 'settings' && (
                        <div style={{ width: '100%', display: 'flex', flexDirection: 'column', height: '100%' }}>
                            {loading ? (
                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', flex: 1 }}>
                                    <div className="spinner-border mb-3 text-brand-primary" role="status" style={{ width: '2rem', height: '2rem' }}></div>
                                    <p className='text-base fw-medium text-dark-ui'>AI is crafting your questions...</p>
                                </div>
                            ) : (
                                <div className="hide-scrollbar" style={{ flex: 1, overflowY: 'auto', display: 'flex', flexDirection: 'column', gap: '14px' }}>

                                    {/* Selected Job */}
                                    <div>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '6px', cursor: 'pointer', userSelect: 'none', marginBottom: '6px' }} onClick={() => setSettingsJobOpen(prev => !prev)}>
                                            <span className="font-size-h4 fw-semibold text-dark-ui">Selected Job</span>
                                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={{ transform: settingsJobOpen ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.2s' }}>
                                                <polyline points="6 9 12 15 18 9" />
                                            </svg>
                                        </div>
                                        {settingsJobOpen && (
                                            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px' }}>
                                                {selectedJobOrDraft.selected ? (
                                                    <span style={{ display: 'inline-flex', alignItems: 'center', padding: '3px 12px', borderRadius: '50rem', fontSize: '13px', fontWeight: 500, background: 'transparent', color: 'var(--brand-primary)', border: '1.5px solid var(--brand-primary)' }}>{selectedJobOrDraft.label}</span>
                                                ) : <span className="font-size-base " style={{ fontStyle: 'italic' }}>None Selected</span>}
                                            </div>
                                        )}
                                    </div>

                                    {/* Selected Topics */}
                                    <div>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '6px', cursor: 'pointer', userSelect: 'none', marginBottom: '6px' }} onClick={() => setSettingsTopicsOpen(prev => !prev)}>
                                            <span className="font-size-h4 fw-semibold text-dark-ui">Selected Topics</span>
                                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={{ transform: settingsTopicsOpen ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.2s' }}>
                                                <polyline points="6 9 12 15 18 9" />
                                            </svg>
                                        </div>
                                        {settingsTopicsOpen && (
                                            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px' }}>
                                                {selectedTopics.length > 0 ? selectedTopics.map((t, idx) => (
                                                    <span key={idx} style={{ display: 'inline-flex', alignItems: 'center', padding: '2px 10px', borderRadius: '50rem', fontSize: '12px', fontWeight: 600, background: 'transparent', color: 'var(--brand-primary)', border: '1.5px solid var(--brand-primary)' }}>{t}</span>
                                                )) : <span className="font-size-base " style={{ fontStyle: 'italic' }}>None Selected</span>}
                                            </div>
                                        )}
                                    </div>

                                    {/* Selected Sub Topics */}
                                    <div>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '6px', cursor: 'pointer', userSelect: 'none', marginBottom: '6px' }} onClick={() => setSettingsSubTopicsOpen(prev => !prev)}>
                                            <span className="font-size-h4 fw-semibold text-dark-ui">Selected Sub Topics</span>
                                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={{ transform: settingsSubTopicsOpen ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.2s' }}>
                                                <polyline points="6 9 12 15 18 9" />
                                            </svg>
                                        </div>
                                        {settingsSubTopicsOpen && (
                                            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px' }}>
                                                {selectedSubTopics.length > 0 ? selectedSubTopics.map((t, idx) => (
                                                    <span key={idx} style={{ display: 'inline-flex', alignItems: 'center', padding: '2px 10px', borderRadius: '50rem', fontSize: '12px', fontWeight: 600, background: 'transparent', color: 'var(--brand-primary)', border: '1.5px solid var(--brand-primary)' }}>{t}</span>
                                                )) : <span className="font-size-base " style={{ fontStyle: 'italic' }}>None Selected</span>}
                                            </div>
                                        )}
                                    </div>

                                    {/* Number of Questions — slider */}
                                    <div>
                                        <label class="font-size-h4 fw-semibold text-dark-ui" >Select Number of Questions</label>
                                        <div style={{ position: 'relative', paddingTop: '32px', paddingLeft: '2px', paddingRight: '2px' }}>
                                            <div style={{
                                                position: 'absolute',
                                                top: 0,
                                                left: `clamp(0px, calc(${((count - 2) / (10 - 2)) * 100}% - 14px), calc(100% - 28px))`,
                                                background: 'var(--brand-primary)',
                                                color: '#fff',
                                                borderRadius: '50%',
                                                width: '28px',
                                                height: '28px',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                fontSize: '12px',
                                                fontWeight: 600,
                                                pointerEvents: 'none'
                                            }}>{count}</div>
                                            <input
                                                type="range"
                                                min="2"
                                                max="10"
                                                value={count}
                                                onChange={(e) => setCount(Number(e.target.value))}
                                                style={{ width: '100%', accentColor: 'var(--brand-primary)', cursor: 'pointer', display: 'block' }}
                                            />
                                            <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '4px' }}>
                                                <span className="font-size-base text-muted">2</span>
                                                <span className="font-size-base text-muted">10</span>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Difficulty Level — 2x2 card grid */}
                                    <div>
                                        <span className="font-size-h4 fw-semibold text-dark-ui" style={{ marginBottom: '10px' }}>Difficulty Level</span>
                                        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px' }}>
                                            {[
                                                { level: 'Easy', description: 'Tests foundational knowledge and basic terminology essential for the role.' },
                                                { level: 'Medium', description: 'Evaluates your ability to apply core concepts to standard workplace scenarios.' },
                                                { level: 'Hard', description: 'Requires advanced problem-solving skills and a deep understanding of complex systems.' },
                                                { level: 'Extremely Hard', description: 'Challenges your ability to innovate or troubleshoot high-pressure, edge-case technical problems.' }
                                            ].map(({ level, description }) => (
                                                <button
                                                    key={level}
                                                    onClick={() => setDifficulty(level)}
                                                    style={{
                                                        padding: '12px 14px',
                                                        borderRadius: '8px',
                                                        border: difficulty === level ? '2px solid var(--brand-primary)' : '1px solid var(--ui-border)',
                                                        background: difficulty === level ? 'var(--color-info-bg)' : '#fff',
                                                        cursor: 'pointer',
                                                        textAlign: 'left',
                                                        display: 'flex',
                                                        flexDirection: 'column',
                                                        gap: '4px'
                                                    }}
                                                >
                                                    <span className="font-size-h4" style={{ fontWeight: 600, color: difficulty === level ? 'var(--brand-primary)' : 'var(--ui-text-dark)' }}>{level}</span>
                                                    <span style={{ fontSize: '11px', color: 'var(--ui-text-muted)', fontWeight: 400, lineHeight: 1.4 }}>{description}</span>
                                                </button>
                                            ))}
                                        </div>
                                    </div>

                                </div>
                            )}
                        </div>
                    )}

                    {activeTab === 'reviewConfig' && (
                        <div className="hide-scrollbar anim-fade" style={{ flex: 1, overflowY: 'auto', width: '100%' }}>
                            <p className="font-size-h4 fw-semibold text-dark-ui" style={{ marginBottom: '16px' }}>Review Your Configuration</p>

                            {/* Selected Job */}
                            <div style={{ marginBottom: '12px' }}>
                                <span className="font-size-h4 fw-semibold text-dark-ui">Selected Job: </span>
                                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px', marginTop: '6px' }}>
                                    {selectedJobOrDraft.selected ? (
                                        <span style={{ display: 'inline-flex', alignItems: 'center', padding: '2px 10px', borderRadius: '50rem', fontWeight: 600, background: 'transparent', color: 'var(--brand-primary)', border: '1.5px solid var(--brand-primary)' }}>{selectedJobOrDraft.label}</span>
                                    ) : <span className="font-size-base " style={{ fontStyle: 'italic', marginLeft: '6px' }}>None Selected</span>}
                                </div>
                            </div>

                            {/* Selected Topics */}
                            <div style={{ marginBottom: '12px' }}>
                                <span className="font-size-h4 fw-semibold text-dark-ui">Selected Topics:</span>
                                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px', marginTop: '6px' }}>
                                    {selectedTopics.length > 0 ? selectedTopics.map((t, i) => (
                                        <span key={i} style={{ display: 'inline-flex', alignItems: 'center', padding: '2px 10px', borderRadius: '50rem', fontWeight: 600, background: 'transparent', color: 'var(--brand-primary)', border: '1.5px solid var(--brand-primary)' }}>{t}</span>
                                    )) : <span className="font-size-base " style={{ fontStyle: 'italic' }}>None Selected</span>}
                                </div>
                            </div>

                            {/* Selected Sub Topics */}
                            <div style={{ marginBottom: '16px' }}>
                                <span className="font-size-h4 fw-semibold text-dark-ui">Selected Sub Topics:</span>
                                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px', marginTop: '6px' }}>
                                    {selectedSubTopics.length > 0 ? selectedSubTopics.map((t, i) => (
                                        <span key={i} style={{ display: 'inline-flex', alignItems: 'center', padding: '2px 10px', borderRadius: '50rem', fontWeight: 600, background: 'transparent', color: 'var(--brand-primary)', border: '1.5px solid var(--brand-primary)' }}>{t}</span>
                                    )) : <span className="font-size-base " style={{ fontStyle: 'italic' }}>None Selected</span>}
                                </div>
                            </div>

                            {/* Number of Questions */}
                            <div style={{ marginBottom: '12px' }}>
                                <span className="font-size-h4 fw-semibold text-dark-ui">Number of Questions: </span>
                                <span className="font-size-base ">{count}</span>
                            </div>

                            {/* Difficulty Level */}
                            <div style={{ marginBottom: '8px' }}>
                                <span className="font-size-h4 fw-semibold text-dark-ui">Difficulty Level: </span>
                                <span className="font-size-base ">{difficulty}</span>
                            </div>
                        </div>
                    )}

                    {activeTab === 'review' && (

                        <div className="panel-body" style={{ background: 'var(--ui-gray-bg)', padding: '16px', gap: '2px', display: 'flex', flexDirection: 'column', animation: 'fadeIn 0.4s ease-out' }}>
                            {questions?.map((q, i) => (
                                <div key={q.id || i} className="dashboard-card" style={{ padding: '12px 16px' }}>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: '1px', marginBottom: '8px' }}>
                                        <p className="font-size-base fw-bold" style={{ margin: 0, flex: 1 }}>{q?.q}</p>
                                        <button className="btn-ghost text-danger" onClick={() => remove(i)} title="Delete Question" style={{ border: 'none', padding: '4px', flexShrink: 0 }}><Icons.Trash /></button>
                                    </div>
                                    <div style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
                                        {q?.options?.map((o, idx) => {
                                            const isCorrect = o === q.correct_answer;
                                            return (
                                                <span
                                                    key={idx}
                                                    className="font-size-base"
                                                    style={{ color: isCorrect ? '#16a34a' : 'var(--ui-text-muted)' }}
                                                >
                                                    {o}
                                                </span>
                                            );
                                        })}
                                    </div>
                                    {q.rationale && (
                                        <div className="mt-2 text-sm " style={{
                                            // padding: '8px 12px',
                                            // border: '1px solid var(--ui-border)',
                                            borderRadius: '6px',
                                            display: 'flex',
                                            gap: '6px',
                                            // fontStyle: 'italic',
                                        }}>
                                            <strong className=" fw-bold" style={{ fontStyle: 'normal', marginRight: '5px' }}>Rationale:</strong>
                                            <span>{q.rationale}</span>
                                        </div>
                                    )}
                                </div>
                            ))}
                        </div>
                    )}
                </div>
                </>
                }
            </div>
        </Modal>
        <AiExecutionLoader isOpen={isGenerating}
            onDismiss={()=>{
                setActiveTab('review')
                setIsGenarating(false);
            }}
            />
            </>
    );
};

const AiGenerator = ({ onImport, initialTopic, buttonLabel = "Generate with AI", buttonStyle,
    setSelectedJobData,
    selectedJobData,
 }) => {
    const [isOpen, setIsOpen] = useState(false);
    const handleImportWrapper = (data) => {
        onImport(data);
        setIsOpen(false);
    };

    useEffect(() => {
        const style = document.createElement('style');
        style.innerHTML = LYWO_CSS;
        document.head.appendChild(style);
        return () => {
            document.head.removeChild(style);
        };
    }, []);

    return (
        <>
            <button
                className="btn btn-primary"
                onClick={() => setIsOpen(true)}
                style={{ ...buttonStyle }}
            >
                {buttonLabel}
            </button>
            {isOpen && (
                <AiWizardModal
                    onClose={() => setIsOpen(false)}
                    onImport={(ques)=>handleImportWrapper(ques)}
                    initialTopic={initialTopic}
                    setSelectedJobData={setSelectedJobData}
                    selectedJobData={selectedJobData}
                />
            )}
            
        </>
    );
};


export default AiGenerator;

